import { connect } from 'react-redux';
import { getFormError, getFormSubmitErrors, hasSubmitSucceeded, isSubmitting } from 'redux-form';

import { FORMS } from 'common/Constants';
import { setPassengerUpdateStatus, unlockBooking } from 'common/SearchStore/SearchActions';
import { getBooking, getPassengerUpdateStatus } from 'common/SearchStore/SearchSelectors';
import { updateBookingId, updateSelectedBookingPassenger } from 'common/UserStore/UserActions';
import { getBookingId, getPassengerNumber } from 'common/UserStore/UserSelectors';
import Booking from './Booking';

const mapStateToProps = (state) => {
  const booking = getBooking(state);
  const mapFunction = (bk) => bk.passengers.find((pass) => pass.pax === getPassengerNumber(state)) || {};
  const passenger = booking.map(mapFunction);
  return {
    booking,
    passengerNumber: getPassengerNumber(state),
    passengerInfo: passenger,
    passengerUpdateStatus: getPassengerUpdateStatus(state),
    submitSucceeded: hasSubmitSucceeded(FORMS.SEARCH)(state),
    submitFailed: getFormError(FORMS.SEARCH)(state),
    submitErrors: getFormSubmitErrors(FORMS.SEARCH)(state),
    isSubmitting: isSubmitting(FORMS.SEARCH)(state),
    clickedBookingId: getBookingId(state),
  };
};

const mapDispatchToProps = (dispatch) => ({
  handleUnlockClicked: (...args) => {
    dispatch(unlockBooking(...args));
    dispatch(updateBookingId(args[0]));
  },
  handleActionClicked: (passengerNumber, cruiseName, bookingId) => {
    dispatch(updateSelectedBookingPassenger({ passengerNumber, cruiseName, bookingId }));
    dispatch(setPassengerUpdateStatus(null));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Booking);
